import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiUsers } from "react-icons/fi";
import { Avatar, Button, Card, EmptyState, Spinner } from "../ui";
import { getCommunityMembers, removeMemberFromCommunity } from "../../api/communities";
import { useToast } from "../../context/ToastContext";
import { useConfirm } from "../../context/ConfirmContext";

export default function MembersTab({ communityId, isAdmin, currentUserId }) {
  const { notify } = useToast();
  const confirm = useConfirm();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getCommunityMembers(communityId)
      .then((res) => setMembers(res.data?.members || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [communityId]);

  const handleRemove = async (memberId, memberName) => {
    const ok = await confirm({
      title: `Remove ${memberName}?`,
      description: `${memberName} will lose access to this community's chat, projects, and events. They can request to rejoin later.`,
    });
    if (!ok) return;
    try {
      await removeMemberFromCommunity(communityId, memberId);
      setMembers((prev) => prev.filter((m) => m.id !== memberId));
      notify(`${memberName} removed.`, "success");
    } catch {
      notify("Couldn't remove member.", "error");
    }
  };

  if (loading) {
    return (
      <Card className="flex justify-center py-12">
        <Spinner />
      </Card>
    );
  }

  return (
    <Card className="divide-y divide-slate-100">
      {members.length === 0 ? (
        <EmptyState className="border-none" icon={<FiUsers className="h-6 w-6" />} title="No members yet" />
      ) : (
        members.map((m) => (
          <div key={m.id} className="flex items-center justify-between gap-3 p-4">
            <Link to={`/profile/${m.id}`} className="flex items-center gap-3 hover:opacity-80">
              <Avatar name={`${m.name} ${m.lastName || ""}`} size="md" />
              <div>
                <p className="text-sm font-semibold text-slate-800">
                  {m.name} {m.lastName}
                </p>
                <p className="text-xs text-slate-400">{m.email}</p>
              </div>
            </Link>
            {isAdmin && m.id !== currentUserId && (
              <Button size="sm" variant="outlineDanger" onClick={() => handleRemove(m.id, m.name)}>
                Remove
              </Button>
            )}
          </div>
        ))
      )}
    </Card>
  );
}
